<template>
  <Modal
	v-model="isShow"
  :width="700"
  :loading="loading"
  :mask-closable="false"
  @on-ok="ok"
  >
    <h3 slot="header" class="modal-header">服务工单详情</h3>
		<Form class="page-wrapper" v-if="item">
			<Row :gutter="5">
				<Col span='10'>
					<FormItem label="项目名称：">
						<span>{{item.projectName}}</span>
					</FormItem>
				</Col>
				<Col span='10'>
					<FormItem label="房间号：">
					<span>{{item.houseNumber}}</span>
					</FormItem>
				</Col>
			</Row>
			<Row  :gutter="5">
				<Col span='10'>
					<FormItem label="合同号：">
						<span>{{item.contractCode}}</span>
					</FormItem>
				</Col>
				<Col  span='10'>
					<FormItem label="工单状态：">
					<span>{{item.orderStatusName}}</span>
					</FormItem>
				</Col>
			</Row>
			<Row  :gutter="5">
				<Col span='10'>
					<FormItem label="一级分类：">
						<span>{{item.orderTypeParentName}}</span>
					</FormItem>
				</Col>
				<Col  span='10'>
					<FormItem label="二级分类：">
					<span>{{item.orderTypeName}}</span>
					</FormItem>
				</Col>
			</Row>
			<Row  :gutter="5">
				<Col span='10'>
					<FormItem label="创建时间：">
						<span>{{item.createDate}}</span>
					</FormItem>
				</Col>
				<Col  span='10'>
					<FormItem label="预计办结时间：">
					<span>{{item.exceptDealTime}}</span>
					</FormItem>
				</Col>
			</Row>
			<Row  :gutter="20">
				<Col span='10'>
					<FormItem label="办理人：">
						<span>{{item.dealZoName}}</span>
					</FormItem>
				</Col>
				<Col  span='10'>
					<FormItem label="得分：">
					<span>{{item.dealZoScore}}</span>
					</FormItem>
				</Col>
			</Row>
			<Row  :gutter="20" v-if="item.orderStatus">
				<Col span='10'>
					<FormItem label="答谢人：">
						<span>{{item.thankZoName}}</span>
					</FormItem>
				</Col>
				<Col  span='10'>
					<FormItem label="得分：">
					<span>{{item.thankZoScore}}</span>
					</FormItem>
				</Col>
			</Row>
			<Row  :gutter="20" v-if="item.orderStatus">
				<Col span='10'>
					<FormItem label="办理时间：">
						<span>{{item.dealTime}}</span>
					</FormItem>
				</Col>
			</Row>
			<Row  :gutter="20">
				<Col span='10'>
					<FormItem label="描述：">
						<span>{{item.remark}}</span>
					</FormItem>
				</Col>
			</Row>

		</Form>
  </Modal>
</template>

<script>
import { findWorkOrderDetail } from 'api/workOrder'
import {deepClone,formatDateTime} from "../../../../../../utils/format";

export default {
	props:{
		c:{
			type:Number,
			default:0,
		},
		item:{
			type:Object,
			default: null,
		},
	},
	data(){
		return{
			isShow:false,
			loading:false,
		}
	},
	watch:{
		c(){
			this.isShow = true
			if(this.item){
				this.item.createDate = this.format(this.item.createDate)
				this.item.exceptDealTime = this.format(this.item.exceptDealTime)
				this.item.dealTime = this.format(this.item.dealTime)
			}
		}
	},
	methods:{
		ok(){

		},
		format(data, showTime = true) {
      if (!data) {
        return ''
      }
      return formatDateTime(data, showTime)
    },
	}
}
</script>

<style>

</style>